import i18n from 'i18n';
import { TableCell } from 'components/TableItems';
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import {
  ServerFields,
  ServerMonitoringStatusEnum,
} from 'modules/environments/interfaces';
import React from 'react';

const getMonitoringStatusText = (server: ServerFields) => {
  if (!server.monitoring_management_enabled) return i18n.t('DISABLED_KEY');

  const options = {
    [ServerMonitoringStatusEnum.DOWN]: i18n.t(
      'SERVER_MONITORING_STATUS.DOWN_KEY'
    ),
    [ServerMonitoringStatusEnum.UP]: i18n.t('SERVER_MONITORING_STATUS.UP_KEY'),
    [ServerMonitoringStatusEnum.TROUBLE]: i18n.t(
      'SERVER_MONITORING_STATUS.TROUBLE_KEY'
    ),
    [ServerMonitoringStatusEnum.CRITICAL]: i18n.t(
      'SERVER_MONITORING_STATUS.CRITICAL_KEY'
    ),
    [ServerMonitoringStatusEnum.SUSPENDED]: i18n.t(
      'SERVER_MONITORING_STATUS.SUSPENDED_KEY'
    ),
    [ServerMonitoringStatusEnum.MAINTENANCE]: i18n.t(
      'SERVER_MONITORING_STATUS.MAINTENANCE_KEY'
    ),
    [ServerMonitoringStatusEnum.DISCOVERY]: i18n.t(
      'SERVER_MONITORING_STATUS.DISCOVERY_KEY'
    ),
    [ServerMonitoringStatusEnum.CONFIGURATION_ERROR]: i18n.t(
      'SERVER_MONITORING_STATUS.CONFIGURATION_ERROR_KEY'
    ),
    [ServerMonitoringStatusEnum.WITHOUT_MONITOR]: i18n.t(
      'SERVER_MONITORING_STATUS.WITHOUT_MONITOR_KEY'
    ),
    [ServerMonitoringStatusEnum.UNAVAILABLE]: i18n.t(
      'SERVER_MONITORING_STATUS.UNAVAILABLE_KEY'
    ),
  };

  return options[server.monitoringStatus] || server.monitoringStatus;
};

interface ServerMonitoringStatusProps {
  server: ServerFields;
}
const ServerMonitoringStatus = ({ server }: ServerMonitoringStatusProps) => {
  const isStopping = !!server?.is_stopping_monitoring;
  const isLoadingMon = !!server?.isLoadingMonitoringStatus;

  const tooltipText = isStopping
    ? i18n.t('STOPPING_KEY')
    : getMonitoringStatusText(server);

  let content: React.ReactNode = <CircularProgress size={12} />;
  if (isStopping) {
    content = (
      <Grid container alignItems="center" justify="center" wrap="nowrap">
        <CircularProgress size={12} />
        <Typography variant="caption" style={{ marginLeft: 4 }}>
          {i18n.t('STOPPING_KEY')}
        </Typography>
      </Grid>
    );
  } else if (isLoadingMon) {
    content = <CircularProgress size={12} />;
  } else {
    content = getMonitoringStatusText(server) || <CircularProgress size={12} />;
  }

  return (
    <TableCell centerTitle textAlignCenter tooltip={tooltipText}>
      {content}
    </TableCell>
  );
};

export default ServerMonitoringStatus;
